import { Skeleton } from "@/components/ui/skeleton";

function OnlyTableSekeleton({ row = 10, header = true, columns = 6 }) {
  const columnStyle = {
    gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
  };

  return (
    <div className="p-4 space-y-6 max-w-7xl mx-auto w-full mt-5">
      {/* Header Section */}
      {header && (
        <div className="flex justify-between items-center">
          <Skeleton className="h-10 w-48" /> {/* Title */}
          <div className="flex gap-2">
            <Skeleton className="h-10 w-24 rounded-md" />
            <Skeleton className="h-10 w-24 rounded-md" />
          </div>
        </div>
      )}

      {/* Search & Filter */}
      {header && (
        <div className="flex justify-between items-center">
          <Skeleton className="h-9 w-72 rounded-md" />
          <div className="flex gap-2">
            <Skeleton className="h-9 w-24 rounded-md" />
            <Skeleton className="h-9 w-24 rounded-md" />
          </div>
        </div>
      )}

      {/* Table Header */}
      <div className="grid gap-4 px-2" style={columnStyle}>
        {[...Array(columns)].map((_, index) => (
          <Skeleton key={index} className="h-6 w-full col-span-1" />
        ))}
      </div>

      {/* Table Rows (5 placeholder rows) */}
      {[...Array(row)].map((_, i) => (
        <div key={i} className="grid gap-4 px-2" style={columnStyle}>
          {[...Array(columns)].map((_, index) => (
            <Skeleton
              key={index}
              className="h-8 w-full col-span-1 rounded-md"
            />
          ))}
        </div>
      ))}
    </div>
  );
}

export default OnlyTableSekeleton;
